import * as React from 'react';
import { useFiltersContext } from '../contexts/filters';

interface IProps {
	foundPosts: number;
}

const ResultCount = ({ foundPosts }: IProps) => {
	const { searchQuery } = useFiltersContext();

	if (foundPosts && searchQuery.length) {
		return (
			<div className="pfa-result-count">
				{foundPosts} {foundPosts === 1 ? 'result' : 'results'} for &quot;{searchQuery}&quot;
			</div>
		);
	}

	return <></>;
};

ResultCount.displayName = 'ResultCount';

export default ResultCount;
